import { useState } from 'react';

import Icon, { IconName } from '@/components/Icon/Icon';

import useStyles from './QuantityPicker.style';

export default function QuantityPicker({
  min = 1,
  max = 99,
  initialValue = 1,
  onChange,
  classes: propClasses = {},
  value,
  'aria-label': ariaLabel = 'Quantity selector',
}: {
  min?: number;
  max?: number;
  initialValue?: number;
  value?: number;
  onChange: (num: number) => void;
  classes?: {
    value?: string;
  };
  'aria-label'?: string;
}) {
  const { classes, cx } = useStyles();
  const [internalValue, setInternalValue] = useState(initialValue);
  const { value: valueClass } = propClasses;

  const isControlled = value !== undefined;
  const currentValue = isControlled ? value : internalValue;

  const handleIncrement = () => {
    if (currentValue < max) {
      const nextValue = currentValue + 1;
      onChange?.(nextValue);
      if (!isControlled) setInternalValue(nextValue);
    }
  };

  const handleDecrement = () => {
    if (currentValue > min) {
      const nextValue = currentValue - 1;
      onChange?.(nextValue);
      if (!isControlled) setInternalValue(nextValue);
    }
  };

  return (
    <fieldset aria-label={ariaLabel} className={classes.container}>
      <button
        type='button'
        onClick={handleDecrement}
        disabled={currentValue <= min}
        aria-label='Decrease quantity'
        className={classes.button}
      >
        <Icon name={IconName.SUBTRACT} width={16} />
      </button>
      <div
        role='spinbutton'
        aria-valuemin={min}
        aria-valuemax={max}
        aria-valuenow={currentValue}
        aria-label='Selected quantity'
        className={cx(classes.quantityBox, valueClass)}
      >
        {currentValue}
      </div>
      <button
        type='button'
        onClick={handleIncrement}
        disabled={currentValue >= max}
        aria-label='Increase quantity'
        className={classes.button}
      >
        <Icon name={IconName.ADD} width={16} />
      </button>
    </fieldset>
  );
}
